import Vue from 'vue'
import i18n from './lang/i18n'
import App from './App'
import store from "@/store"
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './permission'
import '@/styles/index.scss'
import 'normalize.css/normalize.css'
import VueDND from 'awe-dnd'
import 'animate.css'
import scroll from 'vue-seamless-scroll'
import VueCropper from 'vue-cropper'

Vue.use(VueDND)
Vue.use(ElementUI)
Vue.use(scroll)
Vue.use(VueCropper)
Vue.use(i18n)
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
